var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockCircle = function SvgLockCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#lock-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.82,
    cy: 8.934,
    r: 8.876,
    fill: "#FF1C1C",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M6.164 14.732q-.503 0-.86-.358a1.18 1.18 0 0 1-.359-.861V7.419q0-.503.358-.86a1.18 1.18 0 0 1 .86-.359h.61V4.982q0-1.265.892-2.156a2.94 2.94 0 0 1 2.155-.891q1.265 0 2.156.891.893.892.891 2.156V6.2h.61q.503 0 .86.359.36.358.358.86v6.094q0 .503-.357.861a1.17 1.17 0 0 1-.861.358zm0-1.219h7.313V7.419H6.163zm3.656-1.828q.503 0 .861-.358.359-.357.358-.861 0-.503-.358-.86a1.18 1.18 0 0 0-.86-.359q-.506 0-.861.359-.356.36-.359.86 0 .501.359.861c.359.36.527.36.86.358M7.992 6.2h3.656V4.982q0-.762-.533-1.295a1.76 1.76 0 0 0-1.295-.534q-.762 0-1.295.534a1.76 1.76 0 0 0-.533 1.295z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "lock-circle_svg__a",
    width: 65.751,
    height: 65.752,
    x: -23.055,
    y: -23.941,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_356_4201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_356_4201",
    result: "shape"
  })))));
};
export default SvgLockCircle;